import React, { useEffect } from "react";
import { Box, Typography, Button, Grid } from "@material-ui/core";
import { useStoreState } from "easy-peasy";
import { PRODUCT } from "../../../../../models/websiteTypesConstants";
import AdobeScript from "../../../../../services/adobeScript";

const SuccessToLogin = ({ 
  loginHref = process.env.REACT_APP_ECS_LOGIN_URL
}) => {
  const brandSettings = useStoreState((s) => s.siteSettingsModel.brandSettings);
  const brandColor = brandSettings?.FooterBgColor || "#6a1b9a";
  const successColor = "#2ca66f";

  const textBlockWidth = 520;
  const adobe = new AdobeScript();

  useEffect(() => {
    adobe.event("registrationSuccess");
  }, []);

  return (
    <Box mx="auto" textAlign="center" p={3} marginTop="28px">
      <Typography
        variant="h4"
        style={{ fontSize: 32, color: successColor, fontWeight: 800, marginBottom: 8 }}
      >
        Registration Successful!
      </Typography>

      <Box mx="auto" style={{ maxWidth: textBlockWidth }}>
        <Typography
          variant="body1"
          style={{ fontSize: 21, lineHeight: 1.4, marginBottom: 20, textAlign: 'center', fontWeight: 200 }}
        >
          Use your username and password to log in to the{" "} 
          {brandSettings.ProductName === PRODUCT.Grand.bank 
                  ? 'Grand.bank'
                  : brandSettings.ProductName}<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span> Credit Card Mobile App to track your cards arrival.
        </Typography>
      </Box>

      <Grid container spacing={4} justify="center" alignItems="center" style={{marginBottom: 20, marginTop: 20}}>
        <Grid item>
          <a
            href={brandSettings.ProductName === PRODUCT.Grand.bank ? "https://apps.apple.com/us/app/grand.bank-credit-card/id6772209864" :"https://apps.apple.com/us/app/cfc-mobile-access/id1248074910"}
            target="_blank"
            rel="noopener noreferrer"
            onFocus={() => adobe.event("app_download_click", "iOS")}
          >
            <img
              src="/app_store_black.png"
              alt="Download on the App Store"
              style={{ height: 48 }}
            />
          </a>
        </Grid>
        <Grid item>
          <a
            href={brandSettings.ProductName === PRODUCT.Grand.bank ? "https://play.google.com/store/apps/details?id=com.grandbankcard.mobile" : "https://play.google.com/store/apps/details?id=com.contfinco.andriodapp"}
            target="_blank"
            rel="noopener noreferrer"
            onFocus={() => adobe.event("app_download_click", "Android")}
          >
            <img
              src="/play_store_black.png"
              alt="Get it on Google Play"
              style={{ height: 48 }}
            />
          </a>
        </Grid>
      </Grid>

      <Typography
        variant="h5"
        style={{ fontWeight: 700 }}
      >
        Download the {brandSettings.ProductName === PRODUCT.Grand.bank 
                  ? 'Grand.bank'
                  : brandSettings.ProductName}<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span> Credit Card Mobile App
      </Typography>

      <Box mx="auto" style={{ maxWidth: textBlockWidth, marginBottom: 24 }}>
      <Typography variant="body1" style={{ lineHeight: 1.5, textAlign: 'center', fontWeight: 200 }}>
          Once your card arrives, easily activate on the App!
        </Typography>
        <Typography variant="body2" style={{ lineHeight: 1.5, textAlign: 'center', fontWeight: 200 }}>
          Manage your Account anytime, stay up to date with payments, check your
          balance, update your account information and more!
        </Typography>
      </Box>
    </Box>
  );
};

export default SuccessToLogin;